(function() {
  $(function() {
    document.querySelectorAll('script[data-product-snippet-config]').forEach(function(configNode) {
      var config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (e) {
        return;
      }

      var productWrap = $(config.productWrapSelector || '');
      if (!productWrap.length) return;

      var product = config.product || {};
      (config.productionTimes || []).forEach(function(item) {
        if (!product.variants || !product.variants[item.index]) return;
        product.variants[item.index].production_time = item.value;
      });

      productWrap.off('variantChange.productSnippet').on('variantChange.productSnippet', function(e, variant) {
        productWrap.find('.swatch').each(function() {
          var index = $(this).data('option-index');
          var optionValue = variant.options[index];
          $(this).find('.variant-name').text(optionValue);
          if (optionValue == 'None') {
            if (document.querySelector('.option-adjustable-length')) document.querySelector('.option-adjustable-length').style.display = 'none';
          } else {
            if (document.querySelector('.option-adjustable-length')) document.querySelector('.option-adjustable-length').style.display = 'block';
          }
        });
        if (productWrap.find('.shipping-times-wrap').length > 0) {
          var stWrap = productWrap.find('.shipping-times-wrap');
          if (variant.production_time != null) {
            stWrap.find('.default').hide();
            stWrap.find('.solid-gold').hide();
            stWrap.find('.custom').text(variant.production_time).show();
          } else if (stWrap.find('.solid-gold').length > 0) {
            if (variant.title.toLowerCase().indexOf('solid gold') > -1 || variant.title.toLowerCase().indexOf('white gold') > -1) {
              stWrap.find('.default').hide();
              stWrap.find('.solid-gold').show();
              stWrap.find('.custom').hide();
            } else {
              stWrap.find('.default').show();
              stWrap.find('.solid-gold').hide();
              stWrap.find('.custom').hide();
            }
          }
        }
      });

      new ProductJs(productWrap, product);

      if (config.isBraceletCuff === true) {
        $('.product-wrap .options .selector-wrapper label').each(function() {
          if ($(this).html().indexOf('ize') >= 0) {
            $(this).append('<a href="#sizing-guide" class="scrollTo size-help-trigger">Size Help</a>');
          }
        });
      }
    });

    document.querySelectorAll('script[data-size-property-config]').forEach(function(configNode) {
      var config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (e) {
        return;
      }

      var productWrap = $(config.productWrapSelector || '');
      if (!productWrap.length) return;

      var propertyGroup = productWrap.find(config.propertySelector || '');
      if (!propertyGroup.length) return;

      if (parseInt(config.count, 10) === 0) {
        propertyGroup.remove();
        return;
      }

      if (!config.hasOther) return;

      var freeTextWrap = propertyGroup.find('.property-other-wrap');
      var freeTextInput = freeTextWrap.find('input[type=text]');
      var otherRadios = propertyGroup.find('input[type=radio][data-property-other-option="true"]');
      if (!otherRadios.length) {
        otherRadios = propertyGroup.find('input[type=radio][value="' + config.otherRadioValue + '"]');
      }

      var openCustomInput = function(value) {
        if (!otherRadios.length) return;

        otherRadios.each(function() {
          $(this).prop('checked', true).trigger('change');
        });
        if (value && value.trim() !== '') {
          freeTextInput.val(value.trim());
          freeTextInput.attr('name', 'properties[' + config.otherInputProperty + ']');
          freeTextInput.attr('data-custom-property', config.otherInputProperty);
        }
      };

      var urlParams = new URLSearchParams(window.location.search);
      var sizeParam = urlParams.get('size');
      if (sizeParam && sizeParam.trim() !== '') {
        var applySizeParam = function() {
          openCustomInput(decodeURIComponent(sizeParam));
        };
        setTimeout(applySizeParam, 100);
        setTimeout(applySizeParam, 500);
      }

      var variantParam = urlParams.get('variant');
      if (variantParam) {
        var currentVariantInput = productWrap.find('[name="id"]');
        if (currentVariantInput.length) {
          var variantTitle = currentVariantInput.attr('data-variant-title') || '';
          if (variantTitle && (variantTitle.toLowerCase().includes('custom') || variantTitle.toLowerCase().includes('other'))) {
            setTimeout(function() {
              openCustomInput(sizeParam ? decodeURIComponent(sizeParam) : '');
            }, 100);
          }
        }
      }

      propertyGroup.find('input[type=radio]').off('change.sizeProperty').on('change.sizeProperty', function() {
        if ($(this).is(otherRadios)) {
          freeTextWrap.addClass('open');
          freeTextInput.attr('name', 'properties[' + config.otherInputProperty + ']');
          freeTextInput.attr('data-custom-property', config.otherInputProperty);
        } else {
          freeTextWrap.removeClass('open');
          freeTextInput.removeAttr('name');
          freeTextInput.removeAttr('data-custom-property');
        }
      });

      var validation = function() {
        if ($('.required-if-other-selected').length) {
          if ($('.required-if-other-selected').val().trim().length == 0) {
            $('.required-if-other-selected').addClass('error');
            return false;
          }
          if (
            $('.required-if-other-selected').val() != '' && $('.required-if-other-selected').attr('name') == undefined ||
            $('.required-if-other-selected').val() != '' && $('.required-if-other-selected').attr('name').indexOf('properties') == -1
          ) {
            var element = $('.required-if-other-selected');
            var propertyName = element.data('property');
            if (!propertyName) {
              propertyName = element.data('custom-property');
            }
            if (element.val() != '') {
              element.attr('name', 'properties[' + propertyName + ']');
            } else {
              element.removeAttr('name');
            }
          }
        }
        if (otherRadios.length && otherRadios.filter(':checked').length > 0) {
          if (propertyGroup.find('.property-other-wrap input').val() == '') {
            freeTextWrap.find('input').addClass('error');
            return false;
          }
        }
        return true;
      };

      productWrap.find('.add-to-cart-form').off('submit.sizeProperty').on('submit.sizeProperty', function() {
        return validation();
      });
      productWrap.find('.add-to-cart-form').data('validation', validation);
    });

    document.querySelectorAll('script[data-swatch-other-config]').forEach(function(configNode) {
      var config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (e) {
        return;
      }

      var productWrap = $(config.productWrapSelector || '');
      if (!productWrap.length) return;

      var propertyGroup = productWrap.find(config.propertySelector || '');
      if (!propertyGroup.length) return;

      var configuredOtherValue = config.otherRadioValue || '';
      var configuredPropertyName = config.otherInputProperty || '';
      var freeTextWrap = propertyGroup.find('.other-adjustable-length-wrap');
      var freeTextInput = freeTextWrap.find('input[type="text"]');
      var radioInputs = propertyGroup.find('input[type="radio"]');

      var isOtherValue = function(value) {
        var normalizedValue = String(value || '').trim().toLowerCase();
        var normalizedConfiguredValue = String(configuredOtherValue || '').trim().toLowerCase();
        return normalizedValue !== '' && normalizedValue === normalizedConfiguredValue;
      };

      var updateOtherInputState = function(selectedValue) {
        if (!freeTextWrap.length || !freeTextInput.length) return;

        if (isOtherValue(selectedValue)) {
          freeTextWrap.addClass('open');
          freeTextInput.attr('name', 'properties[' + configuredPropertyName + ']');
          freeTextInput.attr('data-custom-property', configuredPropertyName);
        } else {
          freeTextWrap.removeClass('open');
          freeTextInput.removeAttr('name');
          freeTextInput.removeAttr('data-custom-property');
        }
      };

      radioInputs.off('change.swatchOther').on('change.swatchOther', function() {
        updateOtherInputState(this.value);
      });

      var selectedRadioInput = propertyGroup.find('input[type="radio"]:checked').first();
      updateOtherInputState(selectedRadioInput.length ? selectedRadioInput.val() : '');

      var validation = function() {
        var requiredIfOtherSelected = propertyGroup.find('.required-if-other-selected');
        var radioInput = propertyGroup.find('input[type=radio]:checked').first();
        var otherInput = propertyGroup.find('.other-adjustable-length-wrap input').first();

        if (requiredIfOtherSelected.length > 0) {
          var element = requiredIfOtherSelected.first();
          if (String(element.val() || '') === '') {
            element.addClass('error');
            return false;
          }
          if (
            String(element.val() || '') !== '' &&
            (!element.attr('name') || element.attr('name').indexOf('properties') === -1)
          ) {
            var propertyName = element.attr('data-property') || element.attr('data-custom-property');
            if (propertyName) {
              element.attr('name', 'properties[' + propertyName + ']');
            }
          }
        }

        if (radioInput.length && isOtherValue(radioInput.val())) {
          if (!otherInput.length || String(otherInput.val() || '') === '') {
            if (otherInput.length) otherInput.addClass('error');
            return false;
          }
        }

        return true;
      };

      var addToCartForm = productWrap.find('.add-to-cart-form').first();
      if (addToCartForm.length) {
        addToCartForm.off('submit.swatchOther').on('submit.swatchOther', function() {
          return validation();
        });
        addToCartForm.attr('data-validation', 'validation');
      }
    });

    $(document).off('click.productSnippetSizeHelp').on('click.productSnippetSizeHelp', '.size-help-trigger', function() {
      if ($('#shopify-section-pdp_details').length > 0) {
        $.scrollTo($('#shopify-section-pdp_details'), 1000, { offset: -100 });
        if (!$('#shopify-section-pdp_details .sizing-guide').hasClass('open')) {
          $('#shopify-section-pdp_details .sizing-guide .trigger').click();
        }
        return false;
      }
    });

    if (window.__productSnippetStickyBound) return;
    window.__productSnippetStickyBound = true;
    window.addEventListener('scroll', function() {
      var btnsticky = document.querySelector('.content-available');
      if (!btnsticky) return;
      var btnstickyoffset = btnsticky.offsetTop;
      if (window.pageYOffset >= btnstickyoffset) {
        btnsticky.classList.add('sticky');
      } else {
        btnsticky.classList.remove('sticky');
      }
    });
  });
})();
